<div *ngIf="!isDetail" class="section-header" >
  <div class="d-flex">
    <div class="w-100">
    <div class="container">
      <span class="h2">ARCHIVIO NEWS</span>
    </div>
    </div>
  </div>
</div>

<div  *ngIf="!isDetail" class="w-100 pt-4">
  <div class="d-flex justify-content-center">
    <div class="d-flex justify-content-evenly flex-wrap" style="max-width: 1100px;">
      <div class="col-sm-12 col-md-6 col-lg-4 d-flex justify-content-center" *ngFor="let element of modelList; let i = index;">
        <figure class="news-card" (click)="routeTo('news/'+element.idArticolo)" style="cursor:pointer; overflow: hidden;">
          <div class="image w-100">
            <!-- <img [src]="articolo.imgUrl" loading="lazy" alt="{{ articolo.titolo }}" /> -->
            <!-- <img [src]="articolo.imgUrlById || 'assets/images/placeholder_news_default.webp'"alt="{{ articolo?.titolo }}" class="img-fluid" />
             --><div class="image w-100">
              <img
                style="width:100%;"
                class="picture"
                [src]="getImageSrcById(element.imgId)"
                [title]="element.titolo"
                alt="Not Found"
              />
            </div>
            <!-- <img [src]="articolo?.imgUrlById" alt="{{ articolo?.titolo }}" /> -->

          </div>
          <figcaption>
            <span class="h4">{{ element.titolo }}</span>
            <div style="margin-bottom: 15px; color: #989696;">
              <span style="font-style: italic">Data: </span>
              <span style="font-weight:bold;">{{ element.dataInserimento }}</span>  
            </div>
          </figcaption>
        </figure>
      </div>
    </div>
  </div>
  <div class="w-100 d-flex justify-content-center px-5">
    <button *ngIf="numeroArticoli > pagFine" (click)="visualizzaAltriArticoli()"
      class="col-md-4 col-sm-12 btn btn-info" style="padding-top: 10px; padding-bottom: 10px; cursor:pointer;">
      <span class="h5"> CARICA PIU' NEWS </span>
    </button>
  </div>
</div>

<div *ngIf="articolo && isDetail" class="d-flex justify-content-center py-3">
  <div class="container py-4">
    <div class="row">
      <!-- Colonna sinistra: Immagine e data -->
      <div class="col-md-4 d-flex flex-column align-items-start">
        <div class="w-100 mb-3 border" style="aspect-ratio: 4 / 3; overflow: hidden;">
          <img
            [src]="articolo?.imgUrlById || 'assets/images/placeholder_news_default.webp'"
            alt="{{ articolo?.titolo }}"
            style="width: 100%; height: 100%; object-fit: cover;" />
        </div>
        <div class="ps-1">
          <span class="fw-light fst-italic">Data:</span><br />
          <strong>{{ articolo?.dataInserimento }}</strong>
        </div>
      </div>
  
      <!-- Colonna destra: Titolo e corpo -->
      <div class="col-md-8">
        <h2 class="fw-bold">{{ articolo?.titolo }}</h2>
        <p class="mt-3 corpo-articolo" [innerHTML]="articolo?.corpo" style="text-align: justify;"></p>
        <div class="mt-3 d-flex flex-wrap gap-2">
          <!-- <button *ngIf="showArchiveCta" class="btn btn-outline-primary" (click)="onArchiveCtaClick()">
            <i class="fa fa-file-pdf mr-2" aria-hidden="true"></i> {{ archiveCtaText }}
          </button> -->
          <button
            *ngIf="hasPdfAttachment"
            class="btn btn-primary btn-lg download-button"
            (click)="handleDownloadPdf()"
            [disabled]="isPdfDownloading">
            <ng-container *ngIf="!isPdfDownloading; else downloading">
              <i class="fa fa-file-pdf mr-2" aria-hidden="true"></i> SCARICA ALLEGATO
            </ng-container>
          </button>
        </div>
        <ng-template #downloading>
          Download in corso...
        </ng-template>
      </div>
    </div>
  </div>
</div>